<template>
  <img
    class="image-button elevation-animation transition-animation"
    @click="connectToStrava()"
    src="/images/strava/btn_strava_connectwith_orange.svg"
    alt="continue with strava button"
  />
</template>

<script setup lang="ts">
import StravaHelperService from '@/services/strava-helper'

function connectToStrava() {
  window.location.assign(StravaHelperService.authPage())
}
</script>

<style scoped></style>
